module.exports = __webpack_public_path__ + "static/media/cerMotor.414cdfa6.jpg";